import {
    apiRequest,
    hukumanList,
    hukumanActive,
    hukumanInactive
} from "../../../../../services/adapters/kepegawaian/hukumanService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", hukumanList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", hukumanInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", hukumanActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository